import React, { useState } from "react";
import "./header.css";

interface HeaderProps {
  onScroll: (target: "compra" | "instrumentos" | "history" | "midia") => void;
}

function Header({ onScroll }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleClick = (target: "compra" | "instrumentos" | "history" | "midia") => {
    onScroll(target);
    setIsMenuOpen(false); // Fecha o menu no mobile
  };

  return (
    <header className="header">
      <div className="hamburger" onClick={handleToggleMenu}>
        <span />
        <span />
        <span />
      </div>
      <nav className={isMenuOpen ? "open" : ""}>
        <ul>
          <li onClick={() => handleClick("history")}><a href="#">Quem Somos</a></li>
          <li onClick={() => handleClick("midia")}><a href="#">Ripafactory na mídia</a></li>
          <li onClick={() => handleClick("compra")}><a href="#">Compre seu Instrumento</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
